import React from "react";
import {
  Box,
  Paper,
  Chip,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
  useTheme,
  Typography,
  Stack,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";
import { ROLE_METHODS } from "../../common/functions";
import {
  RoutesUrls,
  ministryRoutes,
  commonRoutes,
} from "../../Services/Routes/APP";
import { useDecodedToken } from "../../Services/Routes/APP/PrivateRoute";

const BatchesOfChilds = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();
  const User = useDecodedToken();

  const location = useLocation();
  let navigationsArray = location?.pathname?.split("/") || [];
  navigationsArray?.reverse().pop();

  const urlNavPoints = navigationsArray;
  const urlEndingPoint = urlNavPoints[0];
  urlNavPoints?.reverse();
  const urlStartPoint = navigationsArray[1];

  const childBatchDetailsHandler = (row) => {
    const { appBasedRole, pluralizeRole } = ROLE_METHODS;
    navigate("/" + appBasedRole(User?.role) + commonRoutes.batch.details, {
      state: {
        detailsType: "batch",
        vaccines: row,
      },
    });
  };

  const headings = [
    "Batch#",
    "Quantity",
    "Type",
    "Expiry Date",
    "Storage Temprature",
    "Received Date",
  ];

  const transactions = [
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
  ];
  return (
    <Box>
      {" "}
      <Paper elevation={1} sx={{ paddingX: 3, paddingTop: 5 }}>
        <Stack>
          <Typography
            variant="h5"
            sx={{ color: theme.palette.text.light, fontWeight: "bold" }}
          >
            Batches{" "}
          </Typography>

          <Typography
            color="text.secondary"
            sx={{ textTransform: "capitalize" }}
          >
            {urlStartPoint}
          </Typography>
        </Stack>{" "}
        <TableContainer>
          <Table sx={{ marginTop: 3 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      borderBottom: "none",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor: theme.palette.secondary.dark,
                        borderRadius: 1,
                        color: theme.palette.primary.main,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {state.node.batches?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 21}`}>
                  <TableCell align="center">{row?.reference_number}</TableCell>
                  <TableCell align="center">{row?.size}</TableCell>
                  <TableCell align="center">{row?.main_type}</TableCell>
                  <TableCell align="center">
                    {row?.expiry_date
                      ? format(new Date(row?.expiry_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row?.previous_temperature}
                  </TableCell>
                  <TableCell align="center">
                    {row?.received_date
                      ? format(new Date(row?.received_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {" "}
                    <Button
                      onClick={() => {
                        childBatchDetailsHandler(row);
                      }}
                    >
                      {" "}
                      see details{" "}
                    </Button>{" "}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default BatchesOfChilds;
